export type ViewMode = 'entries' | 'history' | 'deleted' | 'calendar' | 'settings' | 'support' | 'faq' | 'updates' | 'reporting' | 'team' | 'docs';

export const routeToView: Record<string, ViewMode> = {
  tracked: 'entries',
  exported: 'history',
  deleted: 'deleted',
  calendar: 'calendar',
  settings: 'settings',
  support: 'support',
  faq: 'faq',
  updates: 'updates',
  reporting: 'reporting',
  team: 'team',
  docs: 'docs',
};

export const viewToRoute: Record<ViewMode, string> = {
  entries: '/tracked',
  history: '/exported',
  deleted: '/deleted',
  calendar: '/calendar',
  settings: '/settings',
  support: '/support',
  faq: '/faq',
  updates: '/updates',
  reporting: '/reporting',
  team: '/team',
  docs: '/docs',
};
